export default __webpack_public_path__ + "static/PromptIconTwo-2a7721d1081d2b99e1aba4855e730fb4.png";